import React, { useContext, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import PropTypes from 'prop-types'
import Context from '../context/Context'
import { BankIdSigningActions } from '../helpers/Constants'
import { BackButton } from '../utils/Elements'
import StyleConfig from '../helpers/bankid/StyleConfig'

const QrCodeSvg = ({ fill = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={fill} className="bi bi-qr-code-scan" viewBox="0 0 16 16">
      <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5M.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5M4 4h1v1H4z"/>
      <path d="M7 2H2v5h5zM3 3h3v3H3zm2 8H4v1h1z"/>
      <path d="M7 9H2v5h5zm-4 1h3v3H3zm8-6h1v1h-1z"/>
      <path d="M9 2h5v5H9zm1 1v3h3V3zM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8zm2 2H9V9h1zm4 2h-1v1h-2v1h3zm-4 2v-1H8v1z"/>
      <path d="M12 9h2V8h-2z"/>
    </svg>
  )
}

const BankIDImage = ({ image }) => {
  switch (image) {
  case 'bankid_negative':
    return <Image referrerPolicy='no-referrer' src={'/images/BankID_logo_neg.png'} className='img-fluid' />
  case 'bankid_white':
    return <Image referrerPolicy='no-referrer' src={'/images/BankID_logo_white.png'} className='img-fluid' />
  case 'bankid_black':
    return <Image referrerPolicy='no-referrer' src={'/images/BankID_logo_black.png'} className='img-fluid' />
  case 'bankid_regular':
  default:
    return <Image referrerPolicy='no-referrer' src={'/images/BankID_logo.png'} className='img-fluid' />
  }
}

const SigningChoice = ({ isSubmitting, onClickAction, isLink }) => {
  const context = useContext(Context)
  const config = new StyleConfig(context)

  const [hovered, setHovered] = useState(false)

  if (isLink === true) {
    const { id } = useParams()

    return (
      <div>
        {(context.signingActionId === BankIdSigningActions.MOBILE)
          ? <><div className="row mt-4">
            <div className="col-12 text-center">
              <Link to={`/payment/oneclick/pay/${id}/sign/1${context.url}`}
                className="btn btn-primary bankid"
                style={config.style}
                onMouseOver={() => setHovered(true)}
                onMouseOut={() => setHovered(false)}>
                {(hovered)
                  ? <BankIDImage image={config.hoverImage} />
                  : <BankIDImage image={config.image} />}
                <span>Signera</span>
              </Link>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12 text-center">
              <Link to={`/payment/oneclick/pay/${id}/sign/2${context.url}`}
                className="btn btn-primary bankidqr"
                style={config.style}>
                <QrCodeSvg />
                <span>Signera på annan enhet</span>
              </Link>
            </div>
          </div></>
          : <div className="row mt-2">
            <div className="col-12 text-center">
              <Link to={`/payment/oneclick/pay/${id}/sign/2${context.url}`}
                className="btn btn-primary bankidqr"
                style={config.style}>
                <QrCodeSvg />
                <span>Signera på annan enhet</span>
              </Link>
            </div>
          </div>
        }
        <div className="row mt-4">
          <div className="col-12 text-center">
            <BackButton style={context.style} />
          </div>
        </div>
      </div>
    )
  } else {
    if (context.signingActionId === BankIdSigningActions.MOBILE) {
      return (
        <div>
          <div className="row mt-4">
            <div className="col-12 text-center">
              <button type="submit"
                className="btn btn-primary bankid"
                disabled={isSubmitting}
                data-value={1}
                style={config.style}
                onClick={onClickAction}
                onMouseOver={() => setHovered(true)}
                onMouseOut={() => setHovered(false)}>
                {(hovered)
                  ? <BankIDImage image={config.hoverImage} />
                  : <BankIDImage image={config.image} />}
                <span>Signera</span>
              </button>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12 text-center">
              <button type="submit"
                className="btn btn-primary bankidqr"
                disabled={isSubmitting}
                data-value={2}
                style={config.style}
                onClick={onClickAction}>
                <QrCodeSvg />
                <span>Signera på annan enhet</span>
              </button>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="row mt-4">
          <div className="col-12 text-center">
            <button type="submit"
              className="btn btn-primary bankidqr"
              disabled={isSubmitting}
              data-value={2}
              style={config.style}
              onClick={onClickAction}>
              <QrCodeSvg />
              <span>Signera på annan enhet</span>
            </button>
          </div>
        </div>
      )
    }
  }
}

SigningChoice.propTypes = {
  isSubmitting: PropTypes.bool,
  onClickAction: PropTypes.func,
  isLink: PropTypes.bool
}

QrCodeSvg.propTypes = {
  fill: PropTypes.string
}

BankIDImage.propTypes = {
  image: PropTypes.string
}

export default SigningChoice
